// extracted by mini-css-extract-plugin
export var actionText = "_n7-4";
export var container = "_n7-0";
export var leftSection = "_n7-1";
export var rightSection = "_n7-2";
export var settingsButton = "_n7-6";
export var settingsIcon = "_n7-7";
export var shortcut = "_n7-5";
export var shortcutGroup = "_n7-3";